// @ts-ignore
import {FormConfig, PropertyConfig} from "./FormConfig.ts";

export class TabConfig {

    constructor(
        public readonly tabs: Array<Tab>,
        public readonly entity: string,
    ) {
        this.tabs = tabs;
        this.entity = entity
        tabs[0].Active()
    }

}

export class Tab {
    constructor(
        public readonly title: string,
        public readonly config: FormConfig,
        public active: boolean,
    ) {
        this.title = title;
        this.config = config
        this.active = false;
    }

    Active() {
        this.active = true
        return this;
    }
}
